// extracted by mini-css-extract-plugin
export default {"insurancePortalContainer":"insuranceportal_insurancePortalContainer__hvZPj","textContent":"insuranceportal_textContent__FYONG","spanText":"insuranceportal_spanText__fCmzk"};